export default __webpack_public_path__ + "static/media/6_Still.a0531139.jpg";